module.exports = __webpack_public_path__ + "1706eb7f001a4bae03aef302e58ebaad.svg";